var o=function(o,t){var r=o||{};return t&&(r.root=r.root?"".concat(r.root," ").concat(t):t),r};export{o as default};
